import React from 'react';

export function StepFinishActions() {
  return <></>;
}
